module.exports = __webpack_public_path__ + "media/activity-level/cavapoo-fairly-active-48b388e2.svg";